import React from "react";
import "./styles.scss";
import axios from "axios";

import CreateNewRoute from "./components/createNewRoute";
import RouteTable from "./components/routeTable";
import { setPage } from "./../../store/actions/paginationAction";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

class RouteManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      routeList: [],
      agencies: [],
      total: 0,
      filterAgency: "",
      searchKey: "",
    };
  }
  componentDidMount() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return;
    this.getRouteList();
    this.getAgencies();
  }

  onCreateNewRoute = () => {
    this.getRouteList();
  };

  onChangeFilterAgency = (event) => {
    this.props.setPage("routeTable", 0);
    this.setState({ filterAgency: event.target.value });
  };

  setSearchKey = (value) => {
    this.setState({ searchKey: value });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.currentPage !== prevProps.currentPage ||
      this.props.currentLimit !== prevProps.currentLimit ||
      this.state.filterAgency !== prevState.filterAgency
    ) {
      this.getRouteList();
    }
  }

  getAgencies = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/organizations/api/v1/agency`, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      })
      .then((res) => {
        this.setState({ agencies: res.data.data });
        //console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getRouteList = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/route_management/v1/route`, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
        params: {
          page_index: this.props.currentPage,
          page_size: this.props.currentLimit,
          agency:
            this.state.filterAgency === "" ? null : this.state.filterAgency,
          search_term: this.state.searchKey,
        },
      })
      .then((res) => {
        this.setState({ routeList: res.data.data, total: res.data.count });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  render() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;
    return (
      <div className="main-container">
        <div className="route-container">
          <div className="page-header">
            <div className="page-heading">
              Route Management
              <div className="page-sub-heading">Create and manage route</div>
            </div>
          </div>
          {/* <RouteSchedule /> */}
          {/* <DateRangePicker /> */}
          <CreateNewRoute callBack={this.onCreateNewRoute} />
          <RouteTable
            routeList={this.state.routeList}
            callBack={this.onCreateNewRoute}
            agencies={this.state.agencies}
            currentLimit={this.props.currentLimit}
            currentPage={this.props.currentPage}
            total={this.state.total}
            onChangeFilterAgency={this.onChangeFilterAgency}
            filterAgency={this.state.filterAgency}
            searchKey={this.state.searchKey}
            setSearchKey={this.setSearchKey}
            getRouteList={this.getRouteList}
            setPage={this.props.setPage}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let currentLimit = state.paginationLimit.routeTable
    ? state.paginationLimit.routeTable.currentLimit
    : state.paginationLimit.default.currentLimit;

  let currentPage = state.page.routeTable
    ? state.page.routeTable.currentPage
    : state.page.default.currentPage;

  return { currentLimit, currentPage };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: (page, currentPage) => dispatch(setPage(page, currentPage)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RouteManagement);
